import styled from 'styled-components';

/* eslint-disable */
export const RouteContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
`;
